import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Row, Col, Button } from 'reactstrap'
import Card from '../../comum/components/Card'
import FormInputSimples from '../../comum/components/FormInputSimples'
import { FecharFiltro, Filtro } from '../../comum/components/Icones'
import FormSelectSimples from '../../comum/components/FormSelectSimples'


@inject("store")
@observer
export default class FiltroVeiculos extends Component {

    constructor(props) {

        super(props)

        this.state = {
            maisFiltros: false
        }

        this.controller = this.props.controller

        this.showFiltros = this.showFiltros.bind(this)
        this.filtros = this.filtros.bind(this)
    }

    showFiltros() {
        this.setState({
            maisFiltros: !this.state.maisFiltros
        })
    }

    filtros() {
        return(
            <Row className="pb-0">
                <FormInputSimples
                    style={{height: '38px'}}
                    titulo="Placa" xs={12} sm={12} md={4} lg={4} xl={2}
                    onEnter={() => this.controller.listar()}
                    onChange={(event) => this.controller.setPlaca(event.target.value) }
                />
                {this.state.maisFiltros &&
                    <React.Fragment>
                        <FormSelectSimples
                            titulo="Transportadora" xs={12} sm={12} md={4} lg={4} xl={2} 
                            bloqueado={ this.controller.listaTranportadoras.length === 0 }
                            itens={ this.controller.listaTranportadoras }
                            dado={ this.controller.transpId }
                            onChange={ (event) => this.controller.setTransportadora(event)}
                        />
                        <FormSelectSimples
                            titulo="Cliente" xs={12} sm={12} md={4} lg={4} xl={2} 
                            bloqueado={ this.controller.listaClientes.length === 0 }
                            itens={ this.controller.listaClientes }
                            dado={ this.controller.clienteId }
                            onChange={ (event) => this.controller.setCliente(event)}
                        />
                    </React.Fragment>

                }
                <Col className="col-botoes align-items-end mb-4" xl={3} lg={4} md={6} sm={12} xs={12}>
                        <Button className={`btn-filtros ${this.state.maisFiltros && 'ativo'}`} onClick={ this.showFiltros } outline >
                        { this.state.maisFiltros ?
                            <div><FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/> Menos filtros</div>
                            :
                            <div><Filtro color="#93A0AD" className="mr-2" width="15" height="15"/> Mais filtros</div>
                        }
                    </Button>
                    <Button
                        className="btn-com-bordas-primary btn-filtrar"
                        onClick={ this.controller.listar }
                    >
                        Filtrar
                    </Button>
                </Col>
            </Row>
        )
    }

    render() {
        return (
            <div className="filtros filtro-analise-critica">
                <Card className={`area-form pb-0`}>
                    {this.filtros()}
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/veiculos/components/FiltroVeiculos.js